import { render } from "./MGDialog.vue?vue&type=template&id=e8d99f8c&scoped=true"
import script from "./MGDialog.vue?vue&type=script&lang=js"
export * from "./MGDialog.vue?vue&type=script&lang=js"

import "./MGDialog.vue?vue&type=style&index=0&id=e8d99f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d99f8c"]])

export default __exports__